import React from 'react';
import { Loader } from '@getro/rombo';
import { useGetCompanyDetail } from 'components/organisms/contactDetail/hooks/useCompanyDetail';
import PropTypes from 'prop-types';
import { Flex } from 'rebass/styled-components';
import Company from './company';

const CompanyDetail = ({ contact, type }) => {
  const { companyList, isLoading } = useGetCompanyDetail({ contact, type });

  if (isLoading) {
    return (
      <Flex alignItems="center" justifyContent="center" py="24px">
        <Loader data-testid="loader" />
      </Flex>
    );
  }

  const sortedCompanyList = [...companyList]?.sort((a, b) => {
    // Get work experiences for each company
    const experiencesA = contact.contactWorkExperiences.filter((experience) => experience?.organization?.id === a.id);
    const experiencesB = contact.contactWorkExperiences.filter((experience) => experience?.organization?.id === b.id);

    // Get the most recent date for each company
    const getMostRecentDate = (experiences) => {
      if (!experiences || experiences.length === 0) return null;

      let mostRecent = null;
      let hasCurrentPosition = false;

      experiences.forEach((exp) => {
        // If dateTo is null, it's a current position - treat as most recent
        if (!exp.dateTo) {
          hasCurrentPosition = true;
          return;
        }

        const dateTo = new Date(exp.dateTo);
        if (!mostRecent || dateTo > mostRecent) {
          mostRecent = dateTo;
        }
      });

      // If there's a current position, return a date far in the future to sort it first
      if (hasCurrentPosition) {
        return new Date('9999-12-31');
      }

      return mostRecent;
    };

    const dateA = getMostRecentDate(experiencesA);
    const dateB = getMostRecentDate(experiencesB);

    // Sort by most recent first (descending)
    if (!dateA && !dateB) return 0;
    if (!dateA) return 1;
    if (!dateB) return -1;
    return dateB - dateA;
  });

  return (
    <Flex flexDirection="column" sx={{ gap: '16px' }}>
      {sortedCompanyList?.map((company) => (
        <Company company={company} contact={contact} key={company.id} />
      ))}
    </Flex>
  );
};

CompanyDetail.propTypes = {
  contact: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
};

export default CompanyDetail;
